module.exports = __webpack_public_path__ + "img/CJ-Blossom-Park.e5b1cb21.jpg";